import * as tslib_1 from "tslib";
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import { orchestrator } from 'satcheljs';
import { lazyCleanUpItemClientSide } from 'owa-mail-reading-pane-store';
export default orchestrator(deleteItemsStoreUpdate, function (actionMessage) {
    var e_1, _a;
    var itemContexts = actionMessage.itemContexts;
    try {
        for (var itemContexts_1 = tslib_1.__values(itemContexts), itemContexts_1_1 = itemContexts_1.next(); !itemContexts_1_1.done; itemContexts_1_1 = itemContexts_1.next()) {
            var itemContext = itemContexts_1_1.value;
            lazyCleanUpItemClientSide.importAndExecute({ Id: itemContext.itemId }, itemContext.conversationId);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (itemContexts_1_1 && !itemContexts_1_1.done && (_a = itemContexts_1.return)) _a.call(itemContexts_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
});
//# sourceMappingURL=deleteItemsStoreUpdateOrchestrator.js.map